[ {
  "name" : "AE",
  "label" : "Adverse events",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "AETERM",
    "key" : null,
    "label" : "Reported term for the Adverse Event",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESTDTC",
    "key" : null,
    "label" : "Start Date of Adverse Event",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEONGO",
    "key" : null,
    "label" : "AE Ongoing at the end of the study",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEENDTC",
    "key" : null,
    "label" : "End Date of Adverse Event",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESEV",
    "key" : null,
    "label" : "Severity/Intensity",
    "type" : "Num",
    "length" : 8,
    "format" : "SEV.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEREL",
    "key" : null,
    "label" : "Relation to the research / study ",
    "type" : "Num",
    "length" : 8,
    "format" : "REL.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AERELSP",
    "key" : null,
    "label" : "Relation to the product ",
    "type" : "Num",
    "length" : 8,
    "format" : "REL.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEACN1",
    "key" : null,
    "label" : "None",
    "type" : "Num",
    "length" : 8,
    "format" : "YES1F.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEACN2",
    "key" : null,
    "label" : "Modification of a concomitant treatment",
    "type" : "Num",
    "length" : 8,
    "format" : "YES2F.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEACN3",
    "key" : null,
    "label" : "New concomitant treatment",
    "type" : "Num",
    "length" : 8,
    "format" : "YES3F.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEACN4",
    "key" : null,
    "label" : "Hospitalization",
    "type" : "Num",
    "length" : 8,
    "format" : "YES4F.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AEACN5",
    "key" : null,
    "label" : "Study termination",
    "type" : "Num",
    "length" : 8,
    "format" : "YES5F.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESER",
    "key" : null,
    "label" : "Serious Event",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEFORM2",
    "key" : null,
    "label" : "Load another SAE form?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEFORM3",
    "key" : null,
    "label" : "Load another SAE form?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "CM",
  "label" : "Concomitant treatments",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "CMTRT",
    "key" : null,
    "label" : "Reported name of Treatment / medication",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMROUTE",
    "key" : null,
    "label" : "Route",
    "type" : "Num",
    "length" : 8,
    "format" : "ROUTE.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMDOSTXT",
    "key" : null,
    "label" : "Dose description",
    "type" : "Char",
    "length" : 100,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMDOSU",
    "key" : null,
    "label" : "Dose units",
    "type" : "Num",
    "length" : 8,
    "format" : "UNIT.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMDOSUOT",
    "key" : null,
    "label" : "Other unit specification",
    "type" : "Char",
    "length" : 100,
    "format" : "$100.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMDOSFRQ",
    "key" : null,
    "label" : "Frequency",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMSTDTC",
    "key" : null,
    "label" : "Start Date of Medication",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMONGO",
    "key" : null,
    "label" : "Medication Ongoing at end of the study",
    "type" : "Num",
    "length" : 10,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMENDTC",
    "key" : null,
    "label" : "End Date of Medication",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMINDC",
    "key" : null,
    "label" : "Indication",
    "type" : "Num",
    "length" : 8,
    "format" : "INDIC.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESEQ_1",
    "key" : null,
    "label" : "Indication specification (AE number 1)",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESEQ_2",
    "key" : null,
    "label" : "Indication specification (AE number 2)",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CMINDCSP",
    "key" : null,
    "label" : "Indication specification",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "DA",
  "label" : "Product Accountability",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "TINSNB",
    "key" : null,
    "label" : "Number of tins provided",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "TINRQPRO",
    "key" : null,
    "label" : "Tins delivery request processed?",
    "type" : "Num",
    "length" : 8,
    "format" : "YN.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "TINSREQ",
    "key" : null,
    "label" : "Number of tins requested",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "DAENDTC",
    "key" : null,
    "label" : "Last consumption of study formula date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FORNAME",
    "key" : null,
    "label" : "Name of the formula prescribed",
    "type" : "Char",
    "length" : 100,
    "format" : "$100.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FORBRAND",
    "key" : null,
    "label" : "Brand of the formula prescribed",
    "type" : "Char",
    "length" : 100,
    "format" : "$100.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "TINSRETR",
    "key" : null,
    "label" : "Number of tins retrieved",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "DM",
  "label" : "Demographic data",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "CONR1DTC",
    "key" : null,
    "label" : "Date of ICF (legal representative 1)",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "LR1AGR",
    "key" : null,
    "label" : "Agreement of the legal representative 1",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "CONR2DTC",
    "key" : null,
    "label" : "Date of ICF (legal representative 2)",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "LR2AGR",
    "key" : null,
    "label" : "Agreement of the legal representative 2",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "CONSIDTC",
    "key" : null,
    "label" : "Date of ICF (investigator)",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "BRTHDTC",
    "key" : null,
    "label" : "Date of birth",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "SEX",
    "key" : null,
    "label" : "Gender",
    "type" : "Num",
    "length" : 8,
    "format" : "SEX.",
    "settings" : null,
    "comments" : "x"
  } ]
}, {
  "name" : "DS",
  "label" : "Study termination",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "DSWITH",
    "key" : null,
    "label" : "Completion up to the end of the study",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "DSREAS",
    "key" : null,
    "label" : "Reason for discontinuation",
    "type" : "Num",
    "length" : 8,
    "format" : "REAS.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "DSREASSP",
    "key" : null,
    "label" : "Investigator's decision specification",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "DSCOM",
    "key" : null,
    "label" : "General comments on the CRF",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "FACE",
  "label" : "Findings about functional gastrointestinal disorders",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "VANDN_SC",
    "key" : null,
    "label" : "Adapted Vandenplas score",
    "type" : "Num",
    "length" : 8,
    "format" : "VND.",
    "settings" : null,
    "comments" : "REGURGITATIONS"
  }, {
    "name" : "FGID",
    "key" : null,
    "label" : "Disorder according to Rome IV criteria",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FGIDIMPR",
    "key" : null,
    "label" : "Has the disorder improved?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FGIDIDTC",
    "key" : null,
    "label" : "Start date of improvement",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FGIDDDTC",
    "key" : null,
    "label" : "Date of disorder disappearance",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "FEED",
  "label" : "Feeding data",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "BREASTFD",
    "key" : null,
    "label" : "Breastfeeding",
    "type" : "Num",
    "length" : 8,
    "format" : "YNK.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "BRSFEDTC",
    "key" : null,
    "label" : "Breastfeeding end date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FEEDFDTC",
    "key" : null,
    "label" : "Start date of the first infant formula",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FEEDFOR",
    "key" : null,
    "label" : "Current formula name",
    "type" : "Char",
    "length" : 100,
    "format" : "$100.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FEEDBRAN",
    "key" : null,
    "label" : "Current formula brand",
    "type" : "Char",
    "length" : 100,
    "format" : "$100.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FORMSTU",
    "key" : null,
    "label" : "Current formula start (unit)",
    "type" : "Num",
    "length" : 8,
    "format" : "DWM.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FORMSDTC",
    "key" : null,
    "label" : "Current formula start date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FORMSDUR",
    "key" : null,
    "label" : "Current formula start (duration)",
    "type" : "Num",
    "length" : 8,
    "format" : "8",
    "settings" : null,
    "comments" : "FEEDING HISTORY"
  }, {
    "name" : "FEEDBTL",
    "key" : null,
    "label" : "Average number of bottles per day",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "FEEDING DATA / ePRO*"
  }, {
    "name" : "FEEDBVOL",
    "key" : null,
    "label" : "Average volume of bottles (ml/bottle)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "FEEDING DATA / ePRO*"
  }, {
    "name" : "FEEDVOL",
    "key" : null,
    "label" : "Average total daily consumption (ml/day)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "FEEDING DATA"
  }, {
    "name" : "FEEDNIGH",
    "key" : null,
    "label" : "Number of night feedings (bottles/night)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "FEEDING DATA / ePRO*"
  }, {
    "name" : "FEEDMGW1",
    "key" : null,
    "label" : "Frequency of use of magnesium-rich water",
    "type" : "Num",
    "length" : 8,
    "format" : "FRQF.",
    "settings" : null,
    "comments" : "FEEDING DATA"
  }, {
    "name" : "FEEDREF1",
    "key" : null,
    "label" : "Feeding refusal frequency",
    "type" : "Num",
    "length" : 8,
    "format" : "FRQ2F.",
    "settings" : null,
    "comments" : "FEEDING DATA"
  }, {
    "name" : "QSDTC",
    "key" : null,
    "label" : "Date of completion",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "FEEDMGW2",
    "key" : null,
    "label" : "Frequency of use of magnesium-rich water",
    "type" : "Num",
    "length" : 8,
    "format" : "FRQFF.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "FEEDREF2",
    "key" : null,
    "label" : "Feeding refusal frequency",
    "type" : "Num",
    "length" : 8,
    "format" : "FRQ2FF.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "FEEDIV",
    "key" : null,
    "label" : "Diversification since the last visit?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "FDIVDTC",
    "key" : null,
    "label" : "Start date of diversification",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "FU",
  "label" : "Follow-up informations",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "DIARINS",
    "key" : null,
    "label" : "Instructions to complete ediary received",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "DIACCESS",
    "key" : null,
    "label" : "Access to the ediary received?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "APPSCHED",
    "key" : null,
    "label" : "Has a new appointment been scheduled?",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "STDCONT",
    "key" : null,
    "label" : "Study continuation",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "NEXSVDTC",
    "key" : null,
    "label" : "Next visit date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "GIGER",
  "label" : "GIGER Questionnaire",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSSEQ",
    "key" : null,
    "label" : "Sequence Number",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSCAT",
    "key" : null,
    "label" : "Category of Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSSCAT",
    "key" : null,
    "label" : "Subcategory for Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSTEST",
    "key" : null,
    "label" : "Question Name",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSORRES",
    "key" : null,
    "label" : "Finding in Original Units",
    "type" : "Num",
    "length" : 8,
    "format" : "GIGPRO.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "GIGER_SC",
    "key" : null,
    "label" : "GIGER Total score",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "GIGERCO",
    "key" : null,
    "label" : "GIGER comments",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "ePRO*"
  } ]
}, {
  "name" : "GIGERD",
  "label" : "GIGER Questionnaire (reported values)",
  "variables" : [ {
    "name" : "QSSEQ",
    "key" : null,
    "label" : "Sequence Number",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSCAT",
    "key" : null,
    "label" : "Category of Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSSCAT",
    "key" : null,
    "label" : "Subcategory for Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSTEST",
    "key" : null,
    "label" : "Question Name",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSORRESD",
    "key" : null,
    "label" : "Finding in Original Units",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "giger invest"
  } ]
}, {
  "name" : "GIGERI",
  "label" : "GIGER Questionnaire with investigator ",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "GIGER_ISC",
    "key" : null,
    "label" : "GIGER Total score",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "GIGERICO",
    "key" : null,
    "label" : "GIGER comments",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSSEQ",
    "key" : null,
    "label" : "Sequence Number",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSCAT",
    "key" : null,
    "label" : "Category of Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSSCAT",
    "key" : null,
    "label" : "Subcategory for Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSTEST",
    "key" : null,
    "label" : "Question Name",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "giger invest"
  }, {
    "name" : "QSORRESI",
    "key" : null,
    "label" : "Finding in Original Units",
    "type" : "Num",
    "length" : 8,
    "format" : "GIGPRO.",
    "settings" : null,
    "comments" : "giger invest"
  } ]
}, {
  "name" : "IE",
  "label" : "Eligibility criteria",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "IESEQ",
    "key" : null,
    "label" : "Sequence Number",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "IECAT",
    "key" : null,
    "label" : "Inclusion/Exclusion Category",
    "type" : "char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "IETEST",
    "key" : null,
    "label" : "Inclusion/Exclusion Criterion",
    "type" : "char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "IEORRES",
    "key" : null,
    "label" : "Inclusion/Exclusion Criterion answer",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "MH",
  "label" : "Medical history",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "MHYN",
    "key" : null,
    "label" : "Other pathology",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "MHTERM01",
    "key" : null,
    "label" : "Nervous system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM02",
    "key" : null,
    "label" : "Eyes   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM03",
    "key" : null,
    "label" : "Ears   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM04",
    "key" : null,
    "label" : "Respiratory system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM05",
    "key" : null,
    "label" : "Cardiac system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM06",
    "key" : null,
    "label" : "Vascular system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM07",
    "key" : null,
    "label" : "Gastrointestinal system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM08",
    "key" : null,
    "label" : "Hepatobiliary system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM09",
    "key" : null,
    "label" : "Renal and urinary system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM10",
    "key" : null,
    "label" : "Reproductive system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM11",
    "key" : null,
    "label" : "Endocrine system   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM12",
    "key" : null,
    "label" : "Metabolism and nutrition disorders    ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM13",
    "key" : null,
    "label" : "Infections and infestations   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM14",
    "key" : null,
    "label" : "Musculoskeletal/connective tissue pb  ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM15",
    "key" : null,
    "label" : "Immune system disorders   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM16",
    "key" : null,
    "label" : "Blood and lymphatic system disorders   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM17",
    "key" : null,
    "label" : "Skin/subcutaneous tissue disorders   ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM18",
    "key" : null,
    "label" : "Congenital/familial/genetic pb",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM19",
    "key" : null,
    "label" : "Surgical-medical procedures    ",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM20",
    "key" : null,
    "label" : "Other pathology",
    "type" : "Num",
    "length" : 8,
    "format" : "Yes.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "MHTERM21",
    "key" : null,
    "label" : "Other pathology specification",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : "x"
  } ]
}, {
  "name" : "QS",
  "label" : "Questionnaires",
  "variables" : [ {
    "name" : "QSTDTC_R",
    "key" : null,
    "label" : "Theoretical date of completion",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "recalculR",
    "comments" : "date théorique questionnaire"
  }, {
    "name" : "QSDTC_R",
    "key" : null,
    "label" : "Date of completion",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "recalculR",
    "comments" : "date remplissage questionnaire"
  }, {
    "name" : "GIGER_RSC",
    "key" : null,
    "label" : "GIGER Total score",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "recalculR",
    "comments" : "recup QUALIN score"
  }, {
    "name" : "QUALIN_RSC",
    "key" : null,
    "label" : "QUALIN Total score",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "recalculR",
    "comments" : "recup QUALIN score"
  } ]
}, {
  "name" : "QSCE",
  "label" : "Parent's report functional gastrointestinal disorders",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "NBREG",
    "key" : null,
    "label" : "Average number of regurgitations per day",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "REGURGITATIONS / ePRO*"
  }, {
    "name" : "VOLREG",
    "key" : null,
    "label" : "Average volume of regurgitations",
    "type" : "Num",
    "length" : 8,
    "format" : "RGG.",
    "settings" : null,
    "comments" : "REGURGITATIONS / ePRO*"
  }, {
    "name" : "REGAFML",
    "key" : null,
    "label" : "Regurgitation away from meals",
    "type" : "Num",
    "length" : 8,
    "format" : "RGGFQ.",
    "settings" : null,
    "comments" : "REGURGITATIONS / ePRO*"
  }, {
    "name" : "ONGOREG",
    "key" : null,
    "label" : "Continuous regurgitation (small volumes)",
    "type" : "Num",
    "length" : 8,
    "format" : "RGGFQ.",
    "settings" : null,
    "comments" : "REGURGITATIONS / ePRO*"
  }, {
    "name" : "STOOLS",
    "key" : null,
    "label" : "Average stools consistency",
    "type" : "Num",
    "length" : 8,
    "format" : "STOOL.",
    "settings" : null,
    "comments" : "STOOLS non constp / ePRO*"
  }, {
    "name" : "STOOLOTH",
    "key" : null,
    "label" : "Other stools consistency specification",
    "type" : "Char",
    "length" : 100,
    "format" : "$200.",
    "settings" : null,
    "comments" : "STOOLS non constp / ePRO*"
  }, {
    "name" : "STOOLFRQ",
    "key" : null,
    "label" : "Average number of stools per day",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS non constp / ePRO*"
  }, {
    "name" : "STNBHARD",
    "key" : null,
    "label" : "Number of hard stools (last 7 days)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "STNBFOR",
    "key" : null,
    "label" : "Number of formed stools (last 7 days)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "STNBLOOS",
    "key" : null,
    "label" : "Number of loose stools (last 7 days)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "STNBWAT",
    "key" : null,
    "label" : "Number of watery stools (last 7 days)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "STTOTNB",
    "key" : null,
    "label" : "Total number of stools (last 7 days)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "PAINSTNB",
    "key" : null,
    "label" : "Number of painful defecation?",
    "type" : "Num",
    "length" : 8,
    "format" : "PAIN.",
    "settings" : null,
    "comments" : "STOOLS-constip / ePRO*"
  }, {
    "name" : "QSDIST",
    "key" : null,
    "label" : "Abdominal distension severity",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "QSGAS",
    "key" : null,
    "label" : "Gas / flatulence severity",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "QSCRYTMC",
    "key" : null,
    "label" : "Unexplained crying duration ",
    "type" : "Num",
    "length" : 8,
    "format" : "DUR.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "QSIRRTMC",
    "key" : null,
    "label" : "Fussing / irritability duration",
    "type" : "Num",
    "length" : 8,
    "format" : "DUR.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "QSLEETMC",
    "key" : null,
    "label" : "Day sleep duration",
    "type" : "Char",
    "length" : 5,
    "format" : "$5.",
    "settings" : null,
    "comments" : "SLEEPING / ePRO*"
  }, {
    "name" : "QSSLEEQ",
    "key" : null,
    "label" : "Sleep quality",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "SLEEPING / ePRO*"
  } ]
}, {
  "name" : "QSCO",
  "label" : "Treatments, events and comments reported by the parent",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSCOCM",
    "key" : null,
    "label" : "Treatments given",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "QSCOAE",
    "key" : null,
    "label" : "Events reported",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "ePRO"
  } ]
}, {
  "name" : "QSSAT",
  "label" : "Satisfaction regarding evolution of disorders",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSATFORM",
    "key" : null,
    "label" : "Parents satisfaction on formula use",
    "type" : "Num",
    "length" : 8,
    "format" : "SAT.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QSACFORM",
    "key" : null,
    "label" : "Formula acceptability by the child",
    "type" : "Num",
    "length" : 8,
    "format" : "SAT.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QSREGEV",
    "key" : null,
    "label" : "Evolution of regurgitation by parent",
    "type" : "Num",
    "length" : 8,
    "format" : "IMPVTR.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QREGIDTC",
    "key" : null,
    "label" : "Start date of regurgitation improvement",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QSCONSEV",
    "key" : null,
    "label" : "Evolution of constipation by parent",
    "type" : "Num",
    "length" : 8,
    "format" : "IMPVTCP.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QCONIDTC",
    "key" : null,
    "label" : "Start date of constipation improvement",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QSCOLEV",
    "key" : null,
    "label" : "Evolution of colic by parent",
    "type" : "Num",
    "length" : 8,
    "format" : "IMPVTCL.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "QCOLIDTC",
    "key" : null,
    "label" : "Start date of colic improvement",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "ePRO"
  }, {
    "name" : "REGUREV",
    "key" : null,
    "label" : "Evolution of regurgitation",
    "type" : "Num",
    "length" : 8,
    "format" : "EFF.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "CONSTEV",
    "key" : null,
    "label" : "Evolution of constipation ",
    "type" : "Num",
    "length" : 8,
    "format" : "EFF.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "COLICEV",
    "key" : null,
    "label" : "Evolution of colic ",
    "type" : "Num",
    "length" : 8,
    "format" : "EFF.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "QUALIN",
  "label" : "QUALIN Questionnaire",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "QSTDT",
    "key" : "DATE",
    "label" : "Theoretical date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSDT",
    "key" : "DATE",
    "label" : "Date of completion",
    "type" : "Num",
    "length" : 8,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "QSSEQ",
    "key" : null,
    "label" : "Sequence Number",
    "type" : "Num",
    "length" : 8,
    "format" : "2.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSCAT",
    "key" : null,
    "label" : "Category of Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSSCAT",
    "key" : null,
    "label" : "Subcategory for Questionnaire",
    "type" : "Char",
    "length" : 50,
    "format" : "$50.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSTEST",
    "key" : null,
    "label" : "Question Name",
    "type" : "Char",
    "length" : 500,
    "format" : "$500.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QSORRES",
    "key" : null,
    "label" : "Finding in Original Units",
    "type" : "Num",
    "length" : 8,
    "format" : "QULN.",
    "settings" : null,
    "comments" : "ePRO*"
  }, {
    "name" : "QUALIN_SC",
    "key" : null,
    "label" : "QUALIN total score",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "ePRO*"
  } ]
}, {
  "name" : "SAE",
  "label" : "Serious adverse events",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SVSTDT",
    "key" : "DATE",
    "label" : "Visit date (num)",
    "type" : "Num",
    "length" : 10,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "AETERM",
    "key" : null,
    "label" : "Serious adverse event term",
    "type" : "Char",
    "length" : 200,
    "format" : "$200.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AESERC",
    "key" : null,
    "label" : "AE seriousness criteria ",
    "type" : "Num",
    "length" : 8,
    "format" : "SERC.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAETIME",
    "key" : null,
    "label" : "SAE Hour of onset",
    "type" : "Char",
    "length" : 5,
    "format" : "$5.",
    "settings" : null,
    "comments" : "If \"It resulted in death\" , please clarify"
  }, {
    "name" : "DTHDTC",
    "key" : null,
    "label" : "Date of death",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "If \"It resulted in death\" , please clarify"
  }, {
    "name" : "HOSDTC",
    "key" : null,
    "label" : "Hospitalization - Onset date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "If \"It required hospitalisation/prolongation of existing hospitalisation\" answered before"
  }, {
    "name" : "HOSPONG",
    "key" : null,
    "label" : "Hospitalization ongoing",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : "If \"It required hospitalisation/prolongation of existing hospitalisation\" answered before"
  }, {
    "name" : "HOSEDTC",
    "key" : null,
    "label" : "Hospitalization - End date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : "If \"It required hospitalisation/prolongation of existing hospitalisation\" answered before"
  }, {
    "name" : "SAEACNSF",
    "key" : null,
    "label" : "Action taken on study formula",
    "type" : "Num",
    "length" : 8,
    "format" : "ACTK.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "ACSFSDTC",
    "key" : null,
    "label" : "Study formula interrupted from",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "ACSFONG",
    "key" : null,
    "label" : "Study formula interruption ongoing",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "ACSFEDTC",
    "key" : null,
    "label" : "Study formula interruption end date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "AECONTRT",
    "key" : null,
    "label" : "Medication used to treat event",
    "type" : "Num",
    "length" : 8,
    "format" : "NOYES.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF1DTC",
    "key" : null,
    "label" : "Date of follow-up 1",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF1OUT",
    "key" : null,
    "label" : "Follow-up 1 - Outcome",
    "type" : "Num",
    "length" : 8,
    "format" : "SAEOUT.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF2DTC",
    "key" : null,
    "label" : "Date of follow-up 2",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF2OUT",
    "key" : null,
    "label" : "Follow-up 2 - Outcome",
    "type" : "Num",
    "length" : 8,
    "format" : "SAEOUT.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF3DTC",
    "key" : null,
    "label" : "Date of follow-up 3",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF3OUT",
    "key" : null,
    "label" : "Follow-up 3 - Outcome",
    "type" : "Num",
    "length" : 8,
    "format" : "SAEOUT.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF4DTC",
    "key" : null,
    "label" : "Date of follow-up 4",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "SAEF4OUT",
    "key" : null,
    "label" : "Follow-up 4 - Outcome",
    "type" : "Num",
    "length" : 8,
    "format" : "SAEOUT.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "SC",
  "label" : "Subject Characteristics",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SVSTDT",
    "key" : "DATE",
    "label" : "Visit date (num)",
    "type" : "Num",
    "length" : 10,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "GESTAGEW",
    "key" : null,
    "label" : "Gestational age in weeks",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "GESTAGED",
    "key" : null,
    "label" : "Gestational age in days",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "GESTAGEM",
    "key" : null,
    "label" : "Determination gestional age method",
    "type" : "Num",
    "length" : 8,
    "format" : "GA.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "SCMODLV",
    "key" : null,
    "label" : "Mode of delivery",
    "type" : "Num",
    "length" : 8,
    "format" : "MD.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "SCINFBAL",
    "key" : null,
    "label" : "Number of infants",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "SCRANK",
    "key" : null,
    "label" : "Rank of this pregnancy ",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "FHEIGHTF",
    "key" : null,
    "label" : "Father's Height",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "FHWEIGF",
    "key" : null,
    "label" : "Father's Weight",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "FHEIGHTM",
    "key" : null,
    "label" : "Mother's Height",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "FHWEIGM",
    "key" : null,
    "label" : "Mother's Weight",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "FHWMEAS",
    "key" : null,
    "label" : "Mother's weight measured",
    "type" : "Num",
    "length" : 8,
    "format" : "WM.",
    "settings" : null,
    "comments" : "x"
  } ]
}, {
  "name" : "SV",
  "label" : "Study visits",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SVSTDT",
    "key" : "DATE",
    "label" : "Visit date (num)",
    "type" : "Num",
    "length" : 10,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SVSTDTC",
    "key" : null,
    "label" : "Visit date",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : null,
    "comments" : null
  } ]
}, {
  "name" : "VS",
  "label" : "Vital signs",
  "variables" : [ {
    "name" : "STUDYID",
    "key" : "SYSTEM",
    "label" : "Study Identifier",
    "type" : "Char",
    "length" : 10,
    "format" : "$10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "SUBJID",
    "key" : "SYSTEM",
    "label" : "Subject Identifier",
    "type" : "Char",
    "length" : 4,
    "format" : "$6.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SITEID",
    "key" : "SYSTEM",
    "label" : "Site number",
    "type" : "Char",
    "length" : 5,
    "format" : "$6.",
    "settings" : null,
    "comments" : null
  }, {
    "name" : "VISITNUM",
    "key" : "SYSTEM",
    "label" : "Visit number",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "VISIT",
    "key" : "SYSTEM",
    "label" : "Visit",
    "type" : "Char",
    "length" : 30,
    "format" : "$30.",
    "settings" : "EXAGIS",
    "comments" : null
  }, {
    "name" : "SVSTDT",
    "key" : "DATE",
    "label" : "Visit date (num)",
    "type" : "Num",
    "length" : 10,
    "format" : "ddmmyy10.",
    "settings" : "SAS",
    "comments" : null
  }, {
    "name" : "BWEIGHT",
    "key" : null,
    "label" : "Birth weight",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "BLENGTH",
    "key" : null,
    "label" : "Birth length",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "BHEADCIR",
    "key" : null,
    "label" : "Head circumderence at birth",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "x"
  }, {
    "name" : "WEIGHT",
    "key" : null,
    "label" : "Weight (kg)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "ANTHROPOMETRIC MEASURES"
  }, {
    "name" : "LENGTH",
    "key" : null,
    "label" : "Length (cm)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "ANTHROPOMETRIC MEASURES"
  }, {
    "name" : "HEADCIR",
    "key" : null,
    "label" : "Head circumference (cm)",
    "type" : "Num",
    "length" : 8,
    "format" : "8.",
    "settings" : null,
    "comments" : "ANTHROPOMETRIC MEASURES"
  } ]
} ]